import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { CSVLink } from "react-csv";



// COMPONENTS
import SelectDropdown from "../Shared/SelectDropdown";
// REDUX ACTIONS
import { getArticleManufacturers } from "../../redux/actions/articles";
import { setAlert } from "../../redux/actions/alerts";
// CSS STYLES
import styles from '../../styles/pages/CEListPage.module.css'

const exportHeaders = [
    'Title',
    'Author',
    'Post Date',
    'Manufacturers',
    'Published',
    'URL'
]


const ExportCEDialog = ({
    handleClose,
    pageArticleType,
    // Redux Actions
    setAlert,
    getArticleManufacturers,
    // Redux States
    article: {
        articleManufacturersForFilter,
    },
}) => {

    const todaysDate = (new Date()).toISOString()
    const csvRef = useRef();


    const [startDateRange, setStartDateRange] = useState('');
    const [endDateRange, setEndDateRange] = useState(todaysDate);
    const [downloading, setDownloading] = useState(false);
    const [manufacturerFilter, setManufacturerFilter] = useState('all-manufacturers')
    const [csvData, setCsvData] = useState([]);
    const [csvReady, setCsvReady] = useState(false);
    const [manufacturersFilterOptions, setManufacturersFilterOptions] = useState([])



    useEffect(() => {
        getArticleManufacturers('cont-education-articles')
    }, [getArticleManufacturers])

    useEffect(() => {
            if (articleManufacturersForFilter.length > 0 ) {
                formatManufacturersFilterOptions(articleManufacturersForFilter)
            }
        }, [articleManufacturersForFilter])
    
    const formatManufacturersFilterOptions = (manufacturers) => {
        const formattedOptions = manufacturers.map((manu) => {
            return manu && {
                name: manu.name,
                value: manu.manufacturer_id
            }
        })
        setManufacturersFilterOptions(formattedOptions)
    }

    
    const clearForm = () => {
        handleClose()
        setStartDateRange('')
        setEndDateRange(todaysDate)
        setManufacturerFilter('all-manufacturers')
        setDownloading(false)
    }

    useEffect(() => {
        if (csvReady && csvData?.length > 0) {
            csvRef.current.link.click()
            setCsvReady(false)
            clearForm()
            setDownloading(false)
        }
    }, [csvReady])



    const formatCEManufacturers = (articleMap) => {
        // FILTER ARTICLE MAPS THAT CONTAIN PRODUCTS
        const artMapsWithProducts = articleMap.filter(collab => collab.product_id != null)
        // GET MANUFACTURER OBJECT FROM EACH PRODUCT
        let manufacturers = artMapsWithProducts.map(m => m.Product.Manufacturer);
        // REMOVE DUPLICATE MANUFACTURERS
        const uniqueManufacturers = [...new Map(manufacturers.map(item => [item.manufacturer_id, item])).values()];
        // JOIN MANUFACTURERS NAMES INTO STRING
        let manufacturersString = uniqueManufacturers.map(m => m.name).join(', ');
        return manufacturersString
    }

    const formatURL = (urlTitle) => {
        return `https://www.dentalproductshopper.com/article/${urlTitle}`
    }



    const getCSVData = async () => {
        if (!startDateRange || !endDateRange) {
            return setAlert('Please Select a Date Range', 'warning')
        }
        setDownloading(true)


        const data = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/articles/exportArticles/${pageArticleType}/${startDateRange}/${endDateRange}/${manufacturerFilter}`);
        
        if (data?.data?.length > 0) {
            const newArr = data.data.map(article => {

                return [
                        // ARTICLE TITLE
                        article?.title, 
                        // ARTICLE AUTHOR (ONE AUTHOR)
                        article.User &&  article.User.firstName ? `${article.User.firstName}  ${article.User.lastName}` : 'N/A',
                        // ARTICLE CREATE DATE
                        article?.create_date?.slice(0, 10), 
                        // ARTICLE MANUFATURERS (MULTIPLE MANUFACTURERS)
                        article.ArticleMaps.length > 0 ? formatCEManufacturers(article.ArticleMaps) : 'N/A',
                        // ARTICLE PUBLISH STATUS
                        article.publish ? 'Yes' : 'No',
                        // ARTICLE DPS URL
                        article.urlTitle ? formatURL(article.urlTitle) : 'N/A'
                    ]
            })

            setCsvData(newArr)
            setCsvReady(true)
        } else {
            setAlert('No Cont. Education Articles in that Date Range', 'warning');
            setDownloading(false);
        }


    }

    const handleFilter = (option, filterType) => {
        const filter = filterType
        const value = option

        if (filter === 'manufacturers') {
            setManufacturerFilter(value)
        }

    }

    return (
        (
            <div className={styles.exportForm_main_container}>
                <p className={styles.header_text}>Export Cont. Education</p>

                <div className={styles.exportForm_input_grid}>
                
                    <p className={styles.exportForm_grid_span_4} style={{margin: "0"}}>Select Date Range:</p>
                    
                    <div className={`input_container ${styles.exportForm_grid_span_4}`}>
                        <label>Start Date</label>
                        <input 
                            className={`input_basic input_date`}
                            type='date'
                            name='startDateRange'
                            placeholder="Access End Date"
                            value={startDateRange ? startDateRange?.slice(0, 10) : ''}
                            onChange={(e) => setStartDateRange(e.target.value)}
                        />
                    </div>


                    <div className={`input_container ${styles.exportForm_grid_span_4}`}>
                        <label>End Date</label>
                        <input 
                            className={`input_basic input_date`}
                            type='date'
                            name='endDateRange'
                            placeholder="Access End Date"
                            value={endDateRange ? endDateRange?.slice(0, 10) : ''}
                            onChange={(e) => setEndDateRange(e.target.value)}
                        />
                    </div>


                    <p className={styles.exportForm_grid_span_4} style={{margin: "0"}}>Select Manufacturer:</p>

                    <div className={`input_container ${styles.exportForm_grid_span_4}`}  >
                        <label>Manufacturer</label>
                        <SelectDropdown 
                            options={manufacturersFilterOptions}
                            placeholder={'Select Category:'} 
                            handleSelect={(option) => handleFilter(option, 'manufacturers')}
                            selection={manufacturerFilter ? manufacturerFilter : ''}
                        />

                    </div>
                </div>

                <CSVLink
                    style={{ display: 'none' }}
                    ref={csvRef}
                    headers={exportHeaders}
                    data={csvData}
                    filename={'dps_continuing_education.csv'}>
                </CSVLink>


                {/* BUTTONS */}
                <div className={styles.button_container}>
                    <button 
                        className={styles.exportForm_button_cancel}
                        data-action="close"
                        onClick={() => { clearForm() }}
                    >
                        Cancel
                    </button>
                    <button 
                        className={styles.exportForm_button_confirm}
                        onClick={() => { getCSVData() }}
                    >
                        {downloading ? 'Downloading' : 'Confirm'}
                    </button>
                </div>


            </div>
        )
    );
};

const mapStateToProps = (state) => ({
    article: state.article,
});

export default connect(mapStateToProps, {
    setAlert,
    getArticleManufacturers,
})(ExportCEDialog);
